import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import WhatsAppButton from "@/components/WhatsAppButton";

import AutoHome from "@/pages/auto/AutoHome";
import AutoOfficina from "@/pages/auto/AutoOfficina";
import Noleggio from "@/pages/auto/Noleggio";
import AutoServizi from "@/pages/auto/AutoServizi";

import MotoHome from "@/pages/moto/MotoHome";
import MotoOfficina from "@/pages/moto/MotoOfficina";
import BrandPage from "@/pages/moto/BrandPage";
import RacingTeam from "@/pages/moto/RacingTeam";
import NewsDetail from "@/pages/moto/NewsDetail";
import EventoOffRoad from "@/pages/moto/EventoOffRoad";
import EventiList from "@/pages/moto/EventiList";
import EventoDetail from "@/pages/moto/EventoDetail";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminNews from "@/pages/admin/AdminNews";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminRacingStory from "@/pages/admin/AdminRacingStory";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminJobs from "@/pages/admin/AdminJobs";
import LavoraConNoi from "@/pages/LavoraConNoi";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoi />} />

          <Route path="/auto" element={<AutoHome />} />
          <Route path="/auto/servizi" element={<AutoServizi />} />
          <Route path="/auto/officina" element={<AutoOfficina />} />
          <Route path="/auto/noleggio" element={<Noleggio />} />

          <Route path="/moto" element={<MotoHome />} />
          <Route path="/moto/officina" element={<MotoOfficina />} />
          <Route path="/moto/ktm" element={<BrandPage brand="ktm" />} />
          <Route path="/moto/husqvarna" element={<BrandPage brand="husqvarna" />} />
          <Route path="/moto/gasgas" element={<BrandPage brand="gasgas" />} />
          <Route path="/moto/racing-team" element={<RacingTeam />} />
          <Route path="/moto/racing-team/news/:id" element={<NewsDetail />} />
          <Route path="/moto/evento-off-road" element={<EventoOffRoad />} />
          <Route path="/moto/eventi" element={<EventiList />} />
          <Route path="/moto/eventi/:slug" element={<EventoDetail />} />
          <Route path="/moto/:brand/news/:id" element={<NewsDetail />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="eventi" element={<AdminEvents />} />
            <Route path="lavora-con-noi" element={<AdminJobs />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="racing-story" element={<AdminRacingStory />} />
            <Route path="richieste" element={<AdminRequests />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors closeButton />
        <WhatsAppButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
